import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Routes } from '../state';
import { AdminAnalyticsWithCharts } from './admin/AdminAnalytics/AdminAnalyticsWithCharts';
import { LabelingUIPage } from './label-mapper';
import { Admin } from './admin';
import { MafiConnectPage } from '../components/MafiConnect';
import { V2RedirectWithPath } from './V2Redirect';
import CompanyApp from './CompanyApp';
import { CompanyActivation } from './company-activation';
import { User } from '@hum/api/src/types/User.model';

export const RoleController = React.memo(
  ({ user }: { user: User }) => {
    const isCompany = user?.isCompany || user?.isCompanyAdmin;
    const isAdmin = user?.isAdmin;
    const companyActivationRoutes = [
      Routes.COMPANY_ACTIVATION_CONNECTORS,
      Routes.COMPANY_ACTIVATION_CONNECTORS_ACCOUNTING,
      Routes.COMPANY_ACTIVATION_CONNECTORS_PAYMENT,
      Routes.COMPANY_ACTIVATION_CONNECTORS_BANK,
      Routes.COMPANY_ACTIVATION_DOCUMENT_DATAROOM,
    ];

    return (
      <Switch>
        {isAdmin && (
          <>
            <Route path={Routes.ADMIN} component={Admin} exact />
            <Route
              path={Routes.ADMIN_COMPANY_ANALYTICS}
              component={AdminAnalyticsWithCharts}
            />
            <Route path={Routes.LABEL_MAPPER} component={LabelingUIPage} />
            <Route path={Routes.MAFI_CONNECT} component={MafiConnectPage} />
            {companyActivationRoutes.map((path) => (
              <Route
                key={path}
                path={path}
                exact
                component={CompanyActivation}
              />
            ))}
          </>
        )}

        {isCompany && <CompanyApp />}

        <Route path="*" component={V2RedirectWithPath} />
      </Switch>
    );
  },
  (prev, next) => {
    return (
      prev.user?.isAdmin === next.user?.isAdmin &&
      prev.user?.isCompany === next.user?.isCompany &&
      prev.user?.isFund === next.user?.isFund
    );
  }
);
